import React, { Component } from 'react';
import Sound from 'react-sound';
class getMusic extends Component {


  togglePlay() {
    /*this.setState({ play: !this.state.play });
    console.log(this.audio);
    this.state.play ? this.audio.play() : this.audio.pause();*/
  }
  handleSongLoading =()=>{
    //console.log("handleSongLoading"+Sound.status.PLAYING)
  }
  handleSongPlaying =()=>{
    //console.log("handleSongPlaying"+Sound.status.PLAYING)
  }
  handleSongFinishedPlaying =()=>{
      //console.log("handleSongFinishedPlaying"+Sound.status.PLAYING)
  }
  
  notificarNuevoPedido = () => {
   if ("Notification" in window && Notification.permission === "granted") {
      new Notification("Nuevo Pedido", {
        body: `Tienes pedido(s) nuevo(s) pendiente(s)`,
        icon: "icono.png" // Asegúrate de tener este ícono en tu proyecto
      });
    }
  }
  render() {
      /*return (
      <div>
      <button onClick={this.togglePlay}>{this.state.play ? "Pause" : "Play"}</button>
      </div>
    )*/
    
    return (
      <React.Fragment>
      {(localStorage.timbrar)?
        <React.Fragment>
          <Sound
            url={require('../image/campana_13.mp3')}
            playStatus={Sound.status.PLAYING}
            playFromPosition={0 /* in milliseconds */}
            onLoading={this.handleSongLoading}
            onPlaying={this.handleSongPlaying}
            onFinishedPlaying={this.handleSongFinishedPlaying}
            loop ={true}
            volume ={100}
          />
          {this.notificarNuevoPedido()}
        </React.Fragment>
        :''
      }
      </React.Fragment>

    )
  }
}

export default getMusic;
